import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'fuse-password-reset-email',
  templateUrl: './password-reset-email.component.html',
  styleUrls: ['./password-reset-email.component.scss'],
})
export class FusePasswordResetEmailComponent implements OnInit {

  constructor() {

  }

  ngOnInit() {}

}
